import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import * as thunks from 'features/thunks'
import Player from './player-model'
import {
  CreatePlayerAsync,
  DeletePlayerAsync,
  LoadPlayersAsync,
} from './player-thunk'
const initialState: playerSliceState = {
  player: [],
  selected_player: '',
  is_loading_player: false,
  is_creating_player: false,
  is_deleting_player: false,
}
export interface playerSliceState {
  player: Player[]
  selected_player?: string
  is_loading_player: boolean
  is_creating_player: boolean
  is_deleting_player: boolean
}
export const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    setSelectedplayer: (state, action) => {
      state.selected_player = action.payload
    },
    clearStateplayer: (state) => {
      state.player = []
      state.is_loading_player = false
      state.is_creating_player = false
      state.is_deleting_player = false
    },
    mergeplayer: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_player = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.player = merge(state.player, payload) as any
        }
      }
    },

    add_player: (state, action) => {
      if (action.payload) {
        state.player = [...state.player, action.payload]
      }
    },
    set_player: (state, action) => {
      let { key, value, id } = action.payload
      state.player = state.player.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(thunks.CreateUpdatePlayerAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(
      thunks.CreateUpdatePlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_player = false
        handleResult(action, state)
      },
    )
    builder.addCase(thunks.CreateUpdatePlayerAsync.rejected, (state) => {
      state.is_loading_player = false
    })

    builder.addCase(thunks.GetPlayersAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(thunks.GetPlayersAsync.fulfilled, (state, action) => {
      state.is_loading_player = false
      handleResult(action, state)
    })
    builder.addCase(thunks.GetPlayersAsync.rejected, (state) => {
      state.is_loading_player = false
    })

    builder.addCase(thunks.SetPlayerRolesAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(thunks.SetPlayerRolesAsync.fulfilled, (state, action) => {
      state.is_loading_player = false
      handleResult(action, state)
    })
    builder.addCase(thunks.SetPlayerRolesAsync.rejected, (state) => {
      state.is_loading_player = false
    })

    builder.addCase(thunks.AddPlayerRoleAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(thunks.AddPlayerRoleAsync.fulfilled, (state, action) => {
      state.is_loading_player = false
      handleResult(action, state)
    })
    builder.addCase(thunks.AddPlayerRoleAsync.rejected, (state) => {
      state.is_loading_player = false
    })

    builder.addCase(thunks.RemovePlayerRoleAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(thunks.RemovePlayerRoleAsync.fulfilled, (state, action) => {
      state.is_loading_player = false
      handleResult(action, state)
    })
    builder.addCase(thunks.RemovePlayerRoleAsync.rejected, (state) => {
      state.is_loading_player = false
    })

    builder.addCase(thunks.GetPlayerAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(thunks.GetPlayerAsync.fulfilled, (state, action) => {
      state.is_loading_player = false
      handleResult(action, state)
    })
    builder.addCase(thunks.GetPlayerAsync.rejected, (state) => {
      state.is_loading_player = false
    })

    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPlayersAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(LoadPlayersAsync.fulfilled, (state, action) => {
      state.is_loading_player = false
      if (action.payload) {
        state.player = action.payload
      }
    })
    builder.addCase(LoadPlayersAsync.rejected, (state) => {
      state.is_loading_player = false
    })
    builder.addCase(CreatePlayerAsync.pending, (state) => {
      state.is_creating_player = true
    })
    builder.addCase(CreatePlayerAsync.fulfilled, (state) => {
      state.is_creating_player = false
    })
    builder.addCase(CreatePlayerAsync.rejected, (state) => {
      state.is_creating_player = false
    })
    builder.addCase(DeletePlayerAsync.pending, (state) => {
      state.is_deleting_player = true
    })
    builder.addCase(DeletePlayerAsync.fulfilled, (state, action) => {
      state.is_deleting_player = false
      if (state.player) {
        state.player = state.player.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeletePlayerAsync.rejected, (state) => {
      state.is_deleting_player = false
    })

    builder.addCase(autoThunks.fix_player.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(autoThunks.fix_player.fulfilled, (state, action) => {
      state.is_loading_player = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.fix_player.rejected, (state) => {
      state.is_loading_player = false
    })

    builder.addCase(
      autoThunks.CreateItemPlayer_byPlayerAsync.pending,
      (state) => {
        state.is_loading_player = true
      },
    )
    builder.addCase(
      autoThunks.CreateItemPlayer_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_player = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.CreateItemPlayer_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_player = false
      },
    )

    builder.addCase(
      autoThunks.UpdateItemPlayer_byPlayerAsync.pending,
      (state) => {
        state.is_loading_player = true
      },
    )
    builder.addCase(
      autoThunks.UpdateItemPlayer_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_player = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.UpdateItemPlayer_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_player = false
      },
    )

    builder.addCase(
      autoThunks.DeleteItemPlayer_byPlayerAsync.pending,
      (state) => {
        state.is_loading_player = true
      },
    )
    builder.addCase(
      autoThunks.DeleteItemPlayer_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_player = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.DeleteItemPlayer_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_player = false
      },
    )

    builder.addCase(autoThunks.GetItemPlayer_byPlayerAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(
      autoThunks.GetItemPlayer_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_player = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.GetItemPlayer_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_player = false
      },
    )

    builder.addCase(autoThunks.GetListPlayer_byPlayerAsync.pending, (state) => {
      state.is_loading_player = true
    })
    builder.addCase(
      autoThunks.GetListPlayer_byPlayerAsync.fulfilled,
      (state, action) => {
        state.is_loading_player = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.GetListPlayer_byPlayerAsync.rejected,
      (state) => {
        state.is_loading_player = false
      },
    )
  },
})

function handleResult(action: any, state: playerSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_player = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.player = merge(state.player, payload) as any
    }
  }
}

export const {
  clearStateplayer,
  setSelectedplayer,
  set_player,
  mergeplayer,
  add_player,
} = playerSlice.actions

export const get_player =
  (id?: string) =>
  (state: {
    player: {
      player: Player[]
    }
  }): Player | null => {
    let temp = state?.player?.player?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.player?.player[0] || null
  }
export const get_selected_player = (state: {
  player: playerSliceState
}): Player | null => {
  let id = state?.player?.selected_player
  let temp = state?.player?.player?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_player = (state: {
  player: {
    player: Player[]
  }
}): Player[] => {
  let temp = state?.player?.player
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_player_busy = (state: { player: playerSliceState }) => {
  return (
    state?.player.is_deleting_player ||
    state?.player.is_loading_player ||
    state?.player.is_creating_player
  )
}
export const is_deleting_player_busy = (state: {
  player: playerSliceState
}) => {
  return state?.player.is_deleting_player
}
export const is_loading_player_busy = (state: { player: playerSliceState }) => {
  return state?.player.is_loading_player
}
export const is_creating_player_busy = (state: {
  player: playerSliceState
}) => {
  return state?.player.is_creating_player
}

export default playerSlice.reducer
